import { render, staticRenderFns } from "./ChartWidget.vue?vue&type=template&id=54d4bd3b&"
import script from "./ChartWidget.vue?vue&type=script&lang=js&"
export * from "./ChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports